<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <input
                v-model="date"
                v-bind="attrs"
                v-on="on"
                class="form-input form-input__date mb-3"
                :style="templateStyle"
                :required="templateRequired"
                @keydown.prevent
				@focus="event=>event.target.blur()"
            />
        </template>
        <v-date-picker
            v-model="date"
			:active-picker.sync="activePicker"
            :max="
                futureDates
                    ? '2030-12-31'
                    : new Date().toISOString().substr(0, 10)
            "
            min="1920-01-01"
        ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: "DatePicker",
	props:{
		value: String,
		templateStyle: Object,
		templateRequired: Boolean,
		futureDates: Boolean,
	},
    data() {
        return {
            date: this.value,
            menu: false,
			activePicker: "YEAR",
        };
    },
    watch: {
        menu: function (val) {
            val && setTimeout(() => (this.activePicker = "YEAR"));
        },
        date: function (value) {
            this.$emit("input", value);
            this.menu = false;
        },
    },
};
</script>

<style scoped>
.form-input {
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.form-input__date {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>

<style>
.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: unset !important;
}

.v-text-field > .v-input__control > .v-input__slot:after {
    border-color: unset !important;
    border-style: unset !important;
    border-width: unset !important;
    transform: unset !important;
}
</style>
